<template>
  <div>
    <login-personalize-preview-panel-section class="login-personalize-preview-section-background"
                                             :title="$t('message.loginPersonalize.message.setBackground')">
      <div class="login-personalize-preview-section-background-action">
        <input type="file"
               ref="fileInput"
               @change="setBackground"
               hidden />        

        <div 
             class="login-personalize-preview-section-background-action">
          <app-button 
                      :label="$t('message.campaigns.message.selectImagePhone')"
                      bordered
                      @click="openFileInput(true)">
          </app-button>
  
          <app-button :label="$t('message.campaigns.message.selectImageComputer')"
                      bordered
                      @click="openFileInput(false)">
          </app-button>

          <app-button v-if="hasTemporaryImage"
                      :label="$t('message.campaigns.message.removeImages')"
                      bordered
                      @click="removeImage">
          </app-button>
        </div>

      </div>
    </login-personalize-preview-panel-section>

  </div>

</template>

<script>
import AppButton from "@/components/generic/button/Button";
import LoginPersonalizePreviewPanelSection from "@components/modules/login-personalize/preview/panel/section/LoginPersonalizePreviewPanelSection";

export default {
  components: {
    LoginPersonalizePreviewPanelSection,
    AppButton,
  },

  data() {
    return {
      isMobile: false,
      temporaryImageMobile: undefined,
      temporaryImageDesktop: undefined
    };
  },

  props: {
    item: {
      type: Object,
    },   
  },

  computed: {       
    hasTemporaryImage() {
      return this.temporaryImageMobile || this.temporaryImageDesktop
    }
  },

  methods: {
    openFileInput(isMobile) {
      this.isMobile = isMobile;
      this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
    },
    async setBackground(event) {
      try {
        const fileList = event.target.files;
        const file = fileList[0];
        if(this.isMobile) {
          this.temporaryImageMobile = file;
        } else {
          this.temporaryImageDesktop = file;
        }        

        const img = await this.fileToBase64Image(file);
        const isMobile = this.isMobile;
        
        this.$emit("set-temporary-img", {base64Img: img, isMobile});        
      } catch (error) {
        //
      } 
    },
    fileToBase64Image(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (ev) => {
          resolve(ev.target.result);
        };

        reader.onerror = () => {
          reject(reader.error);
        };

        reader.readAsDataURL(file);
      });
    },
    async saveImage({isMobile, isLastRequest}) {      
        const backgroundId =
          await this.$api.core.account.captiveStyle.background({
            styleId: this.item.id,
            file: isMobile ? this.temporaryImageMobile : this.temporaryImageDesktop,
            isMobile: isMobile,
          });
        if(isLastRequest) {
          this.temporaryImageMobile = undefined;
          this.temporaryImageDesktop = undefined;
        }
        this.$emit("saved", { backgroundId, isMobile });        
    },
    removeImage() {
      this.temporaryImageMobile = undefined;
      this.temporaryImageDesktop = undefined;

      this.$emit("remove-temporary-img", undefined);
    }
  },

  created() {},

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.login-personalize-preview-section-background {
  .login-personalize-preview-section-background-action {
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
  }

  .login-personalize-preview-section-background-action-button {
    border: 1px solid #d6d6d6;
    font-size: 14px;
  }
}
</style>
